import type React from 'react';
import type { Team } from '../../types/graphql-generated';

interface TeamShieldProps {
  team?: Team | null;
  size?: 'small' | 'medium' | 'large';
}

export const TeamShield: React.FC<TeamShieldProps> = ({
  team,
  size = 'small'
}) => {
  if (!team || (!team.shortName && !team.nameShow)) {
    return null;
  }

  const sizeClasses = {
    small: 'w-5 h-5',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex items-center justify-center gap-1">
      {team.shield && (
        <img
          src={team.shield}
          alt={team.nameShow || team.shortName || 'Equipo'}
          className={sizeClasses[size]}
        />
      )}
      {!team.shield && (
        <p className="text-sm text-gray-500">
          {team.shortName || team.nameShow}
        </p>
      )}
    </div>
  );
};
